import React from 'react'
import {FormInputComponent} from "../../../components/form/Form";
import {useSupplierFormItem} from "../providers/SupplierFormItemProvider";
import { Checkbox } from "antd";
import SearchBrandsInput from "../../../components/form/SearchBrandsInput";

const SupplierBrandForm = ({supplierOrg, ...props}) => {

    const {
        profileItem,
        profileIndex,
        onModelChange,
        refresh,
        isEditing,
    } = useSupplierFormItem()

    const onChange = (model) => {
        let selectedId = model.brand?.brandId || model.brand?.id;

        model.is_custom = !!model.is_custom;
        if (model.is_custom) {
            model.brand = undefined;
        }

        console.log('onChange', model)

        return onModelChange(model)
    }

    const isCustom = !!profileItem?.is_custom;
    return (
        <div className="flex flex-col">
            <div className="field-section flex-row">
                <div className="field px-3.5 basis-8/12">
                    <div className="form-group" style={styles.field}>
                        {isCustom ? (
                            <React.Fragment>
                                <FormInputComponent
                                    fieldName="name"
                                    value={profileItem.name}
                                    type="text"
                                    label="Name"
                                    required={true}
                                    placeholder="Enter brand name"
                                    style={styles.field}
                                />

                                <FormInputComponent
                                    fieldName="domain"
                                    value={profileItem.domain}
                                    type="url"
                                    label="Domain (Include https://)"
                                    required={true}
                                    placeholder="https://example.com"
                                    style={styles.field}
                                />
                            </React.Fragment>
                        ) : (
                            <FormInputComponent
                                fieldName="brand"
                                className="search-brand-input [&>.form-group]:mb-0"
                                label={false}
                                type="antd-input"
                                required={!isCustom}
                                value={profileItem.brand || ''}
                            >
                                <SearchBrandsInput
                                    isDisabled={isCustom}
                                    placeholder={"Search by name or domain..."}
                                    onClear={() => {
                                        onModelChange({brand: undefined});
                                    }}
                                    disabledOptions={TB.map(supplierOrg?.brands || [], brand => brand.id || brand.brandId || brand.domain)}
                                />
                            </FormInputComponent>
                        )}


                    </div>
                </div>
                <div className="field px-3.5 basis-4/12">
                    {!profileItem.brand && (
                        <div className="form-group" style={styles.field}>
                            <FormInputComponent
                                type="antd-input"
                                fieldName="is_custom"
                                label="Don't see your brand listed?"
                                labelClassName="pt-0 mb-0.5"
                                value={profileItem.is_custom}
                            >
                                <Checkbox checked={isCustom}>
                                    Add Custom Brand
                                </Checkbox>
                            </FormInputComponent>
                        </div>
                    )}
                </div>
            </div>

            {isCustom && (
                <div className="field-section flex-row">
                    <div className="field px-3.5 basis-6/12">
                        <FormInputComponent
                            fieldName="icon"
                            value={profileItem.icon}
                            type="file"
                            label="Logo"
                            required={true}
                            accept=".jpg,.jpeg,.png,.gif"
                            style={styles.field}
                        />
                    </div>
                </div>
            )}
        </div>
    )
}

export default SupplierBrandForm;

const styles = {
    fieldSection: {
        flexDirection: 'row'
    },
    field: {
        padding: '0 15px',
    },
};